<template>
  <div>
    <h2
      v-if="forename !== '' && surname !== ''"
      class="text-header form-section__title"
    >
      <span
        v-for="(item, index) in $root.t('step3.policyHolder')"
        :key="index"
      >
        {{ item }} <br>
      </span>  <br>
      {{ forename + ' ' + surname }}
    </h2>
    <h2
      v-else
      class="text-header form-section__title"
    >
      <span
        v-for="(item, index) in $root.t('step3.policyHolder')"
        :key="index"
      >
        {{ item }} <br>
      </span>
    </h2>
    <div
      v-if="!$formData.policyDetails.policyHolderInsured"
      class=""
    >
      <span
        v-for="(item, index) in $root.t('step3.policyNotInsured')"
        :key="index"
      >
        {{ item }} <br>
      </span>
    </div>

    <div v-else>
      <BmiForm
        :form-data="additionalDetails.bmi"
        prefix="policy-holder"
      />
      <SupplementaryQuestionForm
        :additional-details="additionalDetails"
        :prefix="'policy-holder'"
      />
    </div>
  </div>
</template>
<script>
import BmiForm from './Form/BmiForm.vue'
import SupplementaryQuestionForm from './Form/SupplementaryQuestionForm.vue'

export default {
  name: 'PolicyHolderDetails',
  components: {
    BmiForm,
    SupplementaryQuestionForm,
  },
  data() {
    return {
      additionalDetails: this.$formData.policyHolder.additionalDetails,

      unit: {
        metric: 0,
        imperial: 1,
      },
      feets: null,
      inches: null,
      stones: null,
      pounds: null,
      metricUnit: true, // false -> imperial foot/feet
      forename: this.$formData.policyHolder.details.forename,
      surname: this.$formData.policyHolder.details.surname,
    }
  },
  mounted() {},
  methods: {
    changeUnit(isMetric) {
      if (isMetric) {
        this.additionalDetails.bmi.unit = this.unit.metric
        this.additionalDetails.bmi.kilograms = undefined
        this.additionalDetails.bmi.centimeters = undefined
      } else {
        this.additionalDetails.bmi.unit = this.unit.imperial
        this.additionalDetails.bmi.feets = undefined
        this.additionalDetails.bmi.inches = undefined
        this.additionalDetails.bmi.stones = undefined
        this.additionalDetails.bmi.pounds = undefined
      }

      this.metricUnit = isMetric
    },
    changeInsuranceProvider(status) {
      if (status) {
        this.additionalDetails.insuranceProvider = {
          coverEndDate: null,
          providerCompanyName: '',
        }
      } else {
        this.form.insuranceProvider = null
      }
    },
  },
}
</script>
